const FAKE_FUNCTION = () => undefined;

export { FAKE_FUNCTION };
//# sourceMappingURL=common.js.map
